import React, { Component } from 'react';
import { connect } from 'react-redux';

class BootstrapSuccessError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: false,
    };
  }
  componentDidMount() {
    if (!this.props.permanent) {
      setTimeout(() => {
        this.setState({ timeout: true });
      }, 3000);
    }
  }

  render() {
    const { type, message, dataLocale } = this.props;
    const { ERROR, SUCCESS } = dataLocale;
    return (
      <React.Fragment>
        {!this.state.timeout && (
          <React.Fragment>
            {type === 'error' ? (
              <div className="col-md-12 alert alert-danger">
                <strong>{ERROR}! </strong> {message}
              </div>
            ) : (
              <div className="col-md-12 alert alert-success">
                <strong>{SUCCESS}! </strong> {message}
              </div>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
  };
};

export default connect(mapStateToProps, null)(BootstrapSuccessError);
